$(function () {
  (function () {
    onQuickViewLoaded();
    onQuickViewClose();
    onVariantChange();
    megamenuCols();
    zoomInit();
    PDPVideoInit();
    sorterInit();
    colorSwatchesImagePreview();
    patchCollapsibleHeight();
    faqs();
    fadeInEffect();
  })();

  function onVariantChange() {
    let currentColor = "";
    const animationTime = 400;
    const selectors = {
      variants: '[data-variant-alt]:not([data-variant-alt="no-variant"])',
      featuredImage: "[data-featured-media]",
      visibleVariants: "[data-variant-alt]:visible",
    };
    const galleriesMobile = window.galleries;

    initialDesktopGallery();
    initialFilterMobileCarousel();

    // EVENT
    document.addEventListener("variant:change", function ({ detail }) {
      if (!detail || !detail.colorName) return false;
      const variantValue = detail.value.toLowerCase();
      chnageDesktopGallery(variantValue);
      filterMobileCarousel(variantValue);
    });

    // Check the initial state of the gallery
    function initialDesktopGallery() {
      if (!$(selectors.visibleVariants).length) {
        $(selectors.featuredImage).show();
      }
    }

    // Show and hide proper variant media in desktop gallery
    function chnageDesktopGallery(colorValue) {
      if (colorValue === currentColor) return false;

      currentColor = colorValue;
      const $newVariants = $(`[data-variant-alt="${colorValue}"]`);

      if ($newVariants.length) {
        hideAllVariants();
        $newVariants.fadeIn(animationTime);
      } else if (
        $(selectors.visibleVariants).length === 1 &&
        $(selectors.featuredImage + ":visible").length
      ) {
        return false;
      } else {
        hideAllVariants(true);
      }

      // Show featured image if there are no visible images
      setTimeout(function () {
        if (!$(selectors.visibleVariants).length)
          $(selectors.featuredImage).fadeIn(animationTime);
      }, animationTime + 10);
    }

    // Hide variants with or without animation
    function hideAllVariants(animate = false) {
      if (animate) $(selectors.variants).fadeOut(animationTime);
      else $(selectors.variants).hide();
    }

    // When the PDP is already loaded with a variant
    function initialFilterMobileCarousel() {
      $.each(galleriesMobile, function (key, $gallery) {
        $gallery.slick("slickFilter", `[data-variant-initial-show]`);
        const $sliderImages = $gallery.find(`[data-variant-initial-show]`);
        if (!$sliderImages.length) {
          $gallery.slick("slickUnfilter");
          $gallery.slick("slickFilter", "[data-featured-media-mobile]");
        }
        fakeClick($gallery);
      });
    }

    // Show and hide proper variant media in mobile carousels
    function filterMobileCarousel(colorValue) {
      $.each(galleriesMobile, function (key, $gallery) {
        $gallery.slick("slickUnfilter");
        $gallery.slick(
          "slickFilter",
          `[data-variant-alt-mobile="${colorValue}"], [data-variant-alt-mobile="no-variant"]`
        );
        const $sliderImages = $gallery.find(
          `[data-variant-alt-mobile="${colorValue}"], [data-variant-alt-mobile="no-variant"]`
        );
        if (!$sliderImages.length) {
          $gallery.slick("slickUnfilter");
          $gallery.slick("slickFilter", "[data-featured-media-mobile]");
        }
        fakeClick($gallery);
      });
    }

    // Emulate click on slick to enable the first media item on the gallery
    function fakeClick($gallery) {
      $gallery.find(".item img").first().click();
    }
  }

  /**
   * Initialize JS after a quick modal is loaded
   */
  function onQuickViewLoaded() {
    document.addEventListener("quickview:loaded", function (e) {
      zoomInit();
      PDPVideoInit();
      onVariantChange();
    });
  }

  /**
   * Initialize JS after a quick modal is closed
   */
  function onQuickViewClose() {
    document.addEventListener("quickview:close", function (e) {
      PDPVideosStop();
    });
  }

  /**
   * Initialize media zoom components
   */
  function zoomInit() {
    $("[data-zoom-on-click]").on("click", function () {
      zoomed($(this).attr("src"));
    });

    $(".zoomed-popup .close-zoom").on("click", function () {
      $("body").css("overflow", "auto");
      $(".zoomed-popup").hide();
    });

    function zoomed(imgSrc) {
      $(".zoomed-popup img").attr("src", imgSrc);
      $("body").css("overflow", "hidden");
      $(".zoomed-popup").css("display", "flex");
    }
  }

  /**
   * Initialize PDP play video components
   */
  function PDPVideoInit() {
    $("[data-open-video]").on("click", function () {
      openVideo($(this));
    });
    $(".kings-popup").on("click", function () {
      closeVideo($(this), true);
    });
    $(".kings-popup .close-pp").on("click", function () {
      closeVideo($(this));
    });
    function openVideo($trigger) {
      const videoId = $trigger.data("open-video");
      const $popup = $(".kings-popup");
      const $videoPopupYoutube = $popup;
      const $videoPopup = $popup.find("video");

      if (videoId) {
        $videoPopupYoutube
          .find("iframe")
          .attr("src", `https://www.youtube.com/embed/${videoId}?autoplay=1`);
        $videoPopupYoutube.css("display", "flex");
      } else {
        $videoPopup.play();
        $videoPopup.attr("controls", "true");
      }
    }
    function closeVideo($trigger, parent = false) {
      if (parent) $trigger.hide();
      else $trigger.parents(".kings-popup").hide();
      PDPVideosStop();
    }
  }

  function PDPVideosStop() {
    const $videoTriggers = $("[data-open-video]");
    const $videoTitles = $(".video-product h2");
    const $videoThumbnails = $(".video-product .thumbnail");
    const $youtubeVideos = $(".kings-popup iframe.yt-video");
    const $videoTags = $(".kings-popup video");

    $videoTriggers.show();
    $videoTitles.show();
    $videoThumbnails.show();

    if ($youtubeVideos.length) {
      $youtubeVideos.attr("src", "");
    }
    if ($videoTags.length) {
      $videoTags.stop();
    }
  }

  /**
   * Split the megamenu items in columns to match the design
   */
  function megamenuCols() {
    const $menus = $("[data-megamenu]");
    if (!$menus.length) return false;

    $menus.each(function () {
      const $currentMenu = $(this);
      const supportedSlots = 18;
      let slots = 0;
      let currentColumn = [];
      const columns = [];

      // Split the sub-menu in columns
      const $subMenus = $(this).find("> li.submenu-item");
      $subMenus.each(function () {
        slots += slots > 0 ? 2 : 1; // title or space and title

        const childLenght = $(this).find("> .sub-items > li").length;

        const newItems =
          $(this).data("is-swatch") != 1
            ? childLenght
            : Math.ceil(childLenght / 5);

        if (slots + newItems <= supportedSlots) {
          currentColumn.push($(this));
          slots += newItems;
        } else {
          columns.push(currentColumn);
          currentColumn = [];
          currentColumn.push($(this));
          slots = 0;
          slots += newItems + 1; // plus the title
        }
      });
      if (currentColumn.length) {
        columns.push(currentColumn);
      }

      // Re-draw the menus
      $(this).find("> li.submenu-item").remove();
      $.each(columns, function () {
        const $col = $("<div/>").addClass("col");
        $(this).each(function () {
          $col.append($(this));
        });
        $currentMenu.append($col);
      });
    });
  }

  /**
   * Style the sort by selector from the category/search pages
   */
  function sorterInit() {
    sorter = {
      open: false,
      $label: $("#SortByLabel"),
      $select: $("#SortBy"),
    };

    sorter.$select.on("click", function () {
      if (sorter.open) return;
      sorter.open = true;
      sorter.$label.fadeOut(0);
      sorter.$select.css("opacity", 1);
    });

    $(document).on("click", function (e) {
      if (!sorter.open) return;
      var element = sorter.$select;
      if (!element.is(e.target) && element.has(e.target).length === 0) {
        sorter.open = false;
        sorter.$label.fadeIn(400);
        sorter.$select.css("opacity", 0);
      }
    });
  }

  /**
   * Preview color swatch directly on list pages
   */
  function colorSwatchesImagePreview() {
    const parentSelector = ".image_area";

    $("[data-featured-image]").on("load", function () {
      $(this).parents(parentSelector).removeClass("loading");
    });

    $("[data-color-swatch]").on("click", function (event) {
      event.preventDefault();

      const $item = $(this).closest(".grid__item");
      const $image = $item.find("[data-featured-image]").first();
      const $link = $item.find(".grid-product__link").first();

      const imageSizes = $image.data("widths");
      const newUrl = $(this).data("variant-url");
      const newImg = $(this).data("variant-image");
      const newImgSrcset = [];

      if (newImg) {
        // Create srcset
        imageSizes.forEach(function (element) {
          newImgSrcset.push(
            theme.Images.getSizedImageUrl(newImg, element + "x") +
              " " +
              element +
              "w"
          );
        });

        // Set loading state
        $image.parents(parentSelector).addClass("loading");

        // Update image
        $image.attr("srcset", newImgSrcset.join(", "));
      }

      // Update link
      $link.attr("href", newUrl);

      // Set active state
      $("[data-color-swatch]").removeClass("active");
      $(this).addClass("active");

      if ($(this).attr("data-color-name").split(".")[0]) {
        $item
          .find(".color-swatch__selected")
          .html(
            "<span style='font-weight:600'>Color: </span>" +
              $(this).attr("data-color-name").split(".")[0].replaceAll("-", " ")
          );
      }
    });

    // Reload the listeners if collection page is re rendered
    document.addEventListener("collection:reloaded", function (e) {
      colorSwatchesImagePreview();
    });
  }

  /**
   * Patch collapsible elements so they don't get stucked in height
   */
  function patchCollapsibleHeight() {
    $(window).on("resize", function () {
      $(".collapsible-content--all.is-open").css("height", "auto");
    });
  }
  function fadeInEffect() {
    window.addEventListener("scroll", fadeInSections);
    fadeInSections();
  }
  function fadeInSections() {
    var sections = document.querySelectorAll(".fadein-effect");

    sections.forEach(function (section) {
      if (isElementInViewport(section) < 0) {
        section.classList.add("visible");
      }
    });
  }

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top - window.innerHeight + 20;
  }
  function faqs() {
    $(".content-faqs .faq-item h3").click((event) => {
      $content = $(event.target).closest(".faq-item").find(".answer");
      if (!$content.css("display") || $content.css("display") == "none") {
        $(event.target).find("line")[1].style.display = "none";
        $content.show();
      } else {
        $(event.target).find("line")[1].style.display = "block";
        $content.hide();
      }
    });
  }
});
